export enum BuildingType {
  house = 'house',
  building = 'building',
  unknown = 'unknown'
}
